import {
  AccountBrand,
  AccountConfig,
  DynamicPage,
  SectionData,
  Website,
  WebsiteData,
} from '@betterfunnel/types';

const cleanObj = (obj?: any) => {
  if (!obj) return obj;
  if (typeof obj !== 'object') return obj;

  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, v]) => !!v)
      .map(([k, v]) => [k, v]),
  );
};

export const applyExtras = (
  websiteData: WebsiteData,
  campaign: DynamicPage,
  brand?: AccountBrand,
  config?: AccountConfig,
): WebsiteData => {
  const applySection = (section: SectionData): SectionData => {
    if (section.type === 'footer' && config) {
      const newLinks = section.links;
      if (config.termsOfUseLink) {
        const termsLink = newLinks.find((l) => l.type === 'terms');
        if (termsLink) termsLink.href = config.termsOfUseLink;
      }
      if (config.privacyPolicyLink) {
        const privacyLink = newLinks.find((l) => l.type === 'privacy');
        if (privacyLink) privacyLink.href = config.privacyPolicyLink;
      }
      if (config.links) {
        newLinks.forEach((l) => {
          if (l.type === 'terms' || l.type === 'privacy') return;
          const href = config.links?.[l.type];
          if (href) l.href = href;
        });
      }
    }

    return section;
  };
  return {
    ...websiteData,
    sections: websiteData.sections.map(applySection),
    brand: {
      ...brand,
      ...campaign.brand,
      ...websiteData?.brand,
    },
    config: {
      ...cleanObj(config),
      ...cleanObj(campaign.config),
      ...cleanObj(websiteData.config),
      seo: {
        ...cleanObj(config?.seo),
        ...cleanObj(campaign.config?.seo),
        ...cleanObj(websiteData.config?.seo),
      },
    },
    language: websiteData.language || campaign.language,
  };
};

export const applyExtraData = (
  websiteData: Website,
  campaign: DynamicPage,
  brand?: AccountBrand,
  config?: AccountConfig,
): Website => {
  return {
    ...websiteData,
    development: applyExtras(websiteData.development, campaign, brand, config),
    production: websiteData.production
      ? applyExtras(websiteData.production, campaign, brand, config)
      : undefined,
  };
};
